import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { DateAdapter, MatDialogRef, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA } from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ToastrManager } from "ng6-toastr-notifications";
import { BehaviorSubject, Subject } from "rxjs";
import { PersonalActivoService } from "../../../_core/services/personal-activo.service";
import * as Excel from "exceljs/dist/exceljs";
import * as XLSX from "xlsx";
import { Turno } from "../../../_core/model/turno";
import { Sede } from "../../../_core/model/sede";

export const MY_FORMATS = {
	parse: {
		dateInput: "DD/MM/YYYY",
	},
	display: {
		dateInput: "DD/MM/YYYY",
		monthYearLabel: "MMMM YYYY",
		dateA11yLabel: "DD/MM/YYYY",
		monthYearA11yLabel: "MMMM YYYY",
	},
};

@Component({
	selector: "m-carga-masiva-personal",
	templateUrl: "./carga-masiva-personal.component.html",
	styleUrls: ["./carga-masiva-personal.component.scss"],
	providers: [DatePipe, { provide: MAT_DATE_LOCALE, useValue: "es" }, { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }, { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class CargaMasivaPersonalComponent implements OnInit {
	blobType: string = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	cols = ["Sociedad", "DocumentoIdentidad", "Nombres", "ApellidoPaterno", "ApellidoMaterno", "Activo", "Turno", "Sede","FechaInicioContrato","FechaFinContrato",
		"PlazoContratacion","Genero","EstadoCivil","HijosMenores","EdadHijo","NivelEstudios","FechaNacimiento","Direccion","Ciudad","Telefono","NombreContactoEmergencia",
		"NroContactoEmergencia","Correo","Cargo","SistemaPensiones","Banco","NroCuentaBancaria","NroCuentaInterbancaria"];
	cols_turno = ["Código", "Descripción"];
	cols_sede = ["Código", "Descripción"];
	cols_lista = ["Código", "Descripción"];
	sName: string;
	excelFileName: string;
	viewLoading: boolean = false;
	Archivo = new FormControl();

	load_data: boolean = true;
	no_data: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	@ViewChild(MatSort) MatSort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild("searchInput") searchInput: ElementRef;
	displayedColumns: string[] = ["Respuesta", "Sociedad", "DocumentoIdentidad", "Nombres", "ApellidoPaterno", "ApellidoMaterno", "Activo", "Turno", "Sede",
		"FechaInicioContrato", "FechaFinContrato", "PlazoContratacion", "Genero", "EstadoCivil", "HijosMenores", "EdadHijo", "NivelEstudios", "FechaNacimiento",
		"Direccion", "Ciudad", "Telefono","NombreContactoEmergencia", "NroContactoEmergencia", "Correo", "Cargo", "SistemaPensiones", "Banco",
		"NroCuentaBancaria", "NroCuentaInterbancaria"
	];
	listData: MatTableDataSource<any> = new MatTableDataSource([]);

	searchBan: boolean = false;

	protected _onDestroy = new Subject<void>();

	array_data: any = [];
	array_turnos: Array<Turno> = [];
	array_sedes: Array<Sede> = [];
	array_plazos: any[] = [];
	array_generos: any[] = [];
	array_estados: any[] = [];
	array_ciudades: any[] = [];
	array_cargos: any[] = [];
	array_sistemas: any[] = [];
	array_bancos: any[] = [];

	contIncorrectos: any = 0;
	contCorrectos: any = 0;

	file: File = null;
	arrayBuffer: any;

	fileToUpload: File = null;

	constructor(public dialogRef: MatDialogRef<CargaMasivaPersonalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private _formBuilder: FormBuilder, private toastr: ToastrManager, private change_ref: ChangeDetectorRef, private datePipe: DatePipe, public personalService: PersonalActivoService) {}

	ngOnInit() {
		this.personalService.listarSede().subscribe((response) => {
			this.array_sedes = response as Array<Sede>;
		});

		this.personalService.listarTurno().subscribe((response) => {
			this.array_turnos = response as Array<Turno>;
		});

		this.personalService.listarPlazoContratacion().subscribe((response: any) => {
			this.array_plazos = response;
		});

		this.personalService.listarEstadoCivil().subscribe((response: any) => {
			this.array_estados = response;
		});

		this.personalService.listarGenero().subscribe((response: any) => {
			this.array_generos = response;
		});

		this.personalService.listarCiudad().subscribe((response: any) => {
			this.array_ciudades = response;
		});

		this.personalService.listarCargo().subscribe((response: any) => {
			this.array_cargos = response;
		});

		this.personalService.listarSistemaPensiones().subscribe((response: any) => {
			this.array_sistemas = response;
		});

		this.personalService.listarBanco().subscribe((response: any) => {
			this.array_bancos = response;
		});
	}

	descargarFormatoCarga() {
		this.sName = "Formato_Carga_Personal_Activo";
		this.excelFileName = `${this.sName}.xlsx`;
		const workbook = new Excel.Workbook();
		workbook.creator = "Web";
		workbook.lastModifiedBy = "Web";
		workbook.created = new Date();
		workbook.modified = new Date();
		workbook.addWorksheet(this.sName, { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet = workbook.getWorksheet(1);
		sheet.getColumn(1).width = 30;
		sheet.getRow(1).values = this.cols;

		sheet.columns = [
			{ key: "Sociedad", width: 20 },
			{ key: "DocumentoIdentidad", width: 20 },
			{ key: "Nombres", width: 30 },
			{ key: "ApellidoPaterno", width: 25 },
			{ key: "ApellidoMaterno", width: 25 },
			{ key: "Activo", width: 16 },
			{ key: "Turno", width: 16 },
			{ key: "Sede", width: 16 },
			{ key: "FechaInicioContrato", width: 20 } ,
			{ key: "FechaFinContrato", width: 20 } ,
			{ key: "PlazoContratacion", width: 18 } ,
			{ key: "Genero", width: 16 } ,
			{ key: "EstadoCivil", width: 16 } ,
			{ key: "HijosMenores", width: 16 } ,
			{ key: "EdadHijo", width: 16 } ,
			{ key: "NivelEstudios", width: 16 } ,
			{ key: "FechaNacimiento", width: 16 } ,
			{ key: "Direccion", width: 16 } ,
			{ key: "Ciudad", width: 16 } ,
			{ key: "Telefono", width: 16 } ,
			{ key: "NombreContactoEmergencia", width: 24 } ,
			{ key: "NroContactoEmergencia", width: 24 } ,
			{ key: "Correo", width: 16 } ,
			{ key: "Cargo", width: 16 } ,
			{ key: "SistemaPensiones", width: 18 } ,
			{ key: "Banco", width: 16 } ,
			{ key: "NroCuentaBancaria", width: 24 } ,
			{ key: "NroCuentaInterbancaria", width: 24 }
		];

		["A1", "B1", "C1", "D1", "E1", "F1", "G1", "H1", "I1", "J1", "K1", "L1", "M1", "N1", "O1", "P1", "Q1", "R1", "S1",
		 "T1", "U1", "V1", "W1", "X1", "Y1", "Z1", "AA1", "AB1"].map((key) => {
			sheet.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_data.forEach((item) => {
			sheet.addRow({
				Sociedad: "",
				DocumentoIdentidad: "",
				Nombres: "",
				ApellidoPaterno: "",
				ApellidoMaterno: "",
				Activo: "",
				Turno: "",
				Sede: "",
			});
		});

		workbook.addWorksheet("Turnos", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_2 = workbook.getWorksheet(2);
		sheet_2.getColumn(1).width = 30;
		sheet_2.getRow(1).values = this.cols_turno;

		sheet_2.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 50 },
		];

		["A1", "B1"].map((key) => {
			sheet_2.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_turnos.forEach((item) => {
			sheet_2.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});

		workbook.addWorksheet("Sedes", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_3 = workbook.getWorksheet(3);
		sheet_3.getColumn(1).width = 30;
		sheet_3.getRow(1).values = this.cols_turno;

		sheet_3.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_3.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_sedes.forEach((item) => {
			sheet_3.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});

		workbook.addWorksheet("Plazos Contratación", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_4 = workbook.getWorksheet(4);
		sheet_4.getColumn(1).width = 30;
		sheet_4.getRow(1).values = this.cols_lista;

		sheet_4.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_4.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_plazos.forEach((item) => {
			sheet_4.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});

		workbook.addWorksheet("Género", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_5 = workbook.getWorksheet(5);
		sheet_5.getColumn(1).width = 30;
		sheet_5.getRow(1).values = this.cols_lista;

		sheet_5.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_5.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_generos.forEach((item) => {
			sheet_5.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});

		workbook.addWorksheet("Estado Civil", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_6 = workbook.getWorksheet(6);
		sheet_6.getColumn(1).width = 30;
		sheet_6.getRow(1).values = this.cols_lista;

		sheet_6.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_6.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_estados.forEach((item) => {
			sheet_6.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});


		workbook.addWorksheet("Ciudad", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_7 = workbook.getWorksheet(7);
		sheet_7.getColumn(1).width = 30;
		sheet_7.getRow(1).values = this.cols_lista;

		sheet_7.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_7.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_ciudades.forEach((item) => {
			sheet_7.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});


		workbook.addWorksheet("Cargo", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_8 = workbook.getWorksheet(8);
		sheet_8.getColumn(1).width = 30;
		sheet_8.getRow(1).values = this.cols_lista;

		sheet_8.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_8.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_cargos.forEach((item) => {
			sheet_8.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});


		workbook.addWorksheet("Sistema Pensiones", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_9 = workbook.getWorksheet(9);
		sheet_9.getColumn(1).width = 30;
		sheet_9.getRow(1).values = this.cols_lista;

		sheet_9.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_9.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_sistemas.forEach((item) => {
			sheet_9.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});


		workbook.addWorksheet("Bancos", { views: [{ ySplit: 0, xSplit: 20, activeCell: "A1", showGridLines: true }] });
		const sheet_10 = workbook.getWorksheet(10);
		sheet_10.getColumn(1).width = 30;
		sheet_10.getRow(1).values = this.cols_lista;

		sheet_10.columns = [
			{ key: "Valor", width: 20 },
			{ key: "Nombre", width: 20 },
		];

		["A1", "B1"].map((key) => {
			sheet_10.getCell(key).fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "eaeaea" },
			};
		});

		this.array_bancos.forEach((item) => {
			sheet_10.addRow({
				Valor: item.Valor,
				Nombre: item.Nombre,
			});
		});

		workbook.xlsx.writeBuffer().then((dataReporte) => {
			var file = new Blob([dataReporte], { type: this.blobType });
			if (window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(file, this.excelFileName);
			} else {
				// Others
				var a = document.createElement("a"),
					url = URL.createObjectURL(file);
				a.href = url;
				a.download = this.excelFileName;
				document.body.appendChild(a);
				a.click();
				setTimeout(function () {
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				}, 0);
			}
		});
	}

	chargeFile() {
		//this.formEvento.controls.File.setValue(null);
		let element: HTMLElement = document.getElementById("File") as HTMLElement;
		element.click();
	}

	getFileDATA_2(event) {
		if (event.target.files.length > 0) {
			if (event.target.files[0].size <= 80000000 && event.target.files[0].size !== undefined) {
				const files: { [key: string]: File } = event.target.files;
				for (let key in files) {
					if (!isNaN(parseInt(key))) {
						this.file = files[key];
					}
				}
			} else {
				if (event.target.files[0].size > 80000000) {
					this.toastr.warningToastr("El tamaño excede a los 8Mb de capacidad. No se podra guardar", "Advertencia!", {
						toastTimeout: 2000,
						showCloseButton: true,
						animate: "fade",
						progressBar: true,
					});
				}
				this.file = null;
				this.Archivo.reset();
			}
		}

		this.transform_EXCEL_to_xml();
	}

	transform_EXCEL_to_xml() {
		let waitToastr = this.toastr.infoToastr("Enviando personal activo. Por favor espera...", "Cargando Personal.", {
			dismiss: "controlled",
			showCloseButton: false,
			animate: "fade",
			progressBar: true,
		});

		let fileReader = new FileReader();
		fileReader.readAsArrayBuffer(this.file);
		fileReader.onload = (e) => {
			this.arrayBuffer = fileReader.result;
			var data = new Uint8Array(this.arrayBuffer);
			var arr = new Array();
			for (var i = 0; i !== data.length; ++i) {
				arr[i] = String.fromCharCode(data[i]);
			}
			var bstr = arr.join("");
			var workbook = XLSX.read(bstr, { type: "binary" });
			var first_sheet_name = workbook.SheetNames[0]; // Usuarios
			var worksheetUsuario = workbook.Sheets[first_sheet_name];

			this.listData = new MatTableDataSource([]);
			this.searchBan = false;
			this.load_data = false;
			this.no_data = true;

			var array_carga = XLSX.utils.sheet_to_json(worksheetUsuario, { raw: true });

			console.log(array_carga)

			array_carga.forEach(ac => {
				console.log(this.isDateValid(ac['FechaInicioContrato']))
				console.log(this.isDateValid(ac['FechaInicioContrato']) ? this.datePipe.transform(this.numeroAFecha(ac['FechaInicioContrato']), 'yyyy-MM-dd') : null)
				ac['FechaInicioContrato'] = this.isDateValid(ac['FechaInicioContrato']) ? this.datePipe.transform(this.numeroAFecha(ac['FechaInicioContrato']), 'yyyy-MM-dd') : null;
				ac['FechaFinContrato'] = this.isDateValid(ac['FechaFinContrato']) ? this.datePipe.transform(this.numeroAFecha(ac['FechaFinContrato']), 'yyyy-MM-dd') : null;
				ac['FechaNacimiento'] = this.isDateValid(ac['FechaNacimiento']) ? this.datePipe.transform(this.numeroAFecha(ac['FechaNacimiento']), 'yyyy-MM-dd') : null;
			})

			this.personalService.exportDataExcel(array_carga).subscribe(
				(res: any) => {
					this.load_data = true;
					this.searchBan = false;
					this.array_data = res;

					this.listData = new MatTableDataSource(res);
					if (res.length === 0) {
						this.contIncorrectos = 0;
						this.contCorrectos = 0;
						waitToastr.dismiss();
						this.no_data = false;
					} else {
						this.contIncorrectos = res.filter((item) => item.CodRespuesta === 0).length;
						this.contCorrectos = res.filter((item) => item.CodRespuesta === 1).length;
						this.no_data = true;
						waitToastr.dismiss();
					}
					this.listData.sort = this.MatSort;
					this.listData.paginator = this.paginator;
					this.file = null;
					this.Archivo.reset();
					this.change_ref.markForCheck();
				},
				(errorServicio) => {
					this.file = null;
					this.Archivo.reset();
					console.log(errorServicio);
					waitToastr.dismiss();
					this.toastr.errorToastr("Se produjo un error durante la carga de datos.", "Error!", {
						toastTimeout: 2000,
						showCloseButton: true,
						animate: "fade",
						progressBar: true,
					});
				}
			);
		};
	}

	numeroAFecha(numeroDeDias, esExcel = false) {
		var diasDesde1900 = esExcel ? 25567 + 1 : 25567;
		// 86400 es el número de segundos en un día, luego multiplicamos por 1000 para obtener milisegundos.
		return new Date((numeroDeDias - diasDesde1900) * 86400 * 1000);
	}

	isDateValid(dateStr) {
		return !isNaN(new Date(dateStr).getTime());
	  }

	onSubmit() {
		this.viewLoading = true;
		if (this.array_data.length === 0) {
			this.viewLoading = false;
			this.toastr.warningToastr("No se encontraron datos a importar.", "Advertencia!", {
				toastTimeout: 2000,
				showCloseButton: true,
				animate: "fade",
				progressBar: true,
			});
			return;
		}

		let datosRegistro = this.array_data.filter((item) => item.CodRespuesta === 1);

		if (datosRegistro.length === 0) {
			this.viewLoading = false;
			this.toastr.warningToastr("No hay registros correctos a importar.", "Advertencia!", {
				toastTimeout: 2000,
				showCloseButton: true,
				animate: "fade",
				progressBar: true,
			});
			return;
		}

		this.personalService.SaveUpdateMasivoPersonalActivo(datosRegistro).subscribe(
			(data: any) => {
				if (data > 0) {
					this.dialogRef.close(true);
					this.toastr.successToastr("Se ha guardado con exito", "Éxito!", {
						toastTimeout: 2000,
						showCloseButton: true,
						animate: "fade",
						progressBar: true,
					});
				} else {
					this.viewLoading = false;
					this.toastr.errorToastr("Ha ocurrido un error, intentelo nuevamente", "Error!", {
						toastTimeout: 2000,
						showCloseButton: true,
						animate: "fade",
						progressBar: true,
					});
				}
			},
			(errorServicio) => {
				this.viewLoading = false;
				console.log(errorServicio);
				this.toastr.errorToastr("Ha ocurrido un error, intentelo nuevamente", "Error!", {
					toastTimeout: 2000,
					showCloseButton: true,
					animate: "fade",
					progressBar: true,
				});
				this.change_ref.markForCheck();
			}
		);
	}

	onNoClick(): void {
		this.dialogRef.close();
	}
}
